import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { IModular } from '../model';
import { AclService } from '@aes/acl/acl.service';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AppSwitcherService {


    private moduleState = new ReplaySubject<IModular[]>(1);

    getModuleState(): Observable<IModular[]> {
        return this.moduleState.asObservable();
    }

    /**
     * Constructor
     *
     * @param {HttpClient} _http
     */
    constructor(private _http: HttpClient, private aclService: AclService) { 
        this.aclService.getAccountAbilityState().subscribe(ability => {
            const modularList: IModular[] = [];
            const hasHrmFunc = this.aclService.hasAnyFunction(['FUNC__FUNC_REQUESTER__APPROVAL']);
            if (hasHrmFunc) {
                modularList.push({
                    key: 'hrm',
                    logo: '/assets/images/logos/artstuff_hr.svg',
                    title: 'PERSONEL_MANAGEMENT',
                    url: '/hrm',
                });
            }
            const hasSaleFunc = this.aclService.hasAnyFunction(['FUNC__FUNC_VIEW__SALE_DATA']);
            if (hasSaleFunc) {
                modularList.push({
                    key: 'sale',
                    logo: '/assets/images/logos/artstuff_sales.svg',
                    title: 'ACCOUNTANT',
                    url: '/sale',
                });
            }

            this.moduleState.next(modularList);
        });
    }

}
